import React from 'react';
import { Chip, Tooltip } from '@mui/material';

interface VariantBadgeProps {
  showTooltip?: boolean;
}

/**
 * VariantBadge Component
 *
 * Displays a visual indicator for variant assets.
 * Shows a gray "V" badge next to the layer chip.
 *
 * Design Decision: Gray badge (subtle) with 3% card tint
 */
const VariantBadge: React.FC<VariantBadgeProps> = ({
  showTooltip = true
}) => {
  const badge = (
    <Chip
      label="V"
      size="small"
      sx={{
        fontSize: '0.65rem',
        height: '18px',
        fontWeight: 'bold',
        minWidth: '18px',
        bgcolor: 'grey.600',
        color: 'white',
        '& .MuiChip-label': {
          padding: '0 4px',
        },
      }}
    />
  );

  if (showTooltip) {
    return (
      <Tooltip title="Variant Asset" arrow placement="top">
        {badge}
      </Tooltip>
    );
  }

  return badge;
};

export default VariantBadge;
